import { IntegrationAccount } from '../../../models/integrationAccount';

// Server scoping keeps pagination clean during a purge (a purged mailbox can
// take minutes to actually clear server-side); outside a purge a stale
// connected-accounts list can never hide a newly connected account, so
// "no filter" is safer than substituting one.
export const resolveListingEmailAddresses = (
  filters: string[] | undefined,
  integrationAccounts: ReadonlyArray<Pick<IntegrationAccount, 'displayName'>>,
  hasActiveRemovals: boolean,
): string[] | undefined => {
  if (filters !== undefined) {
    return filters;
  }

  if (!hasActiveRemovals || integrationAccounts.length === 0) {
    return undefined;
  }

  return integrationAccounts.map((account) => account.displayName);
};
